import { format } from 'date-fns';
import { ActingDetailPassengerEventResponse } from '@area-restrita/api-client/model/actingDetailPassengerEventResponse';

export const getBoardingPointsCsvRows = (
  events: ActingDetailPassengerEventResponse[],
) =>
  events
    .filter(({ kind }) => kind === 'boarding')
    .sort(
      (a, b) =>
        new Date(a.measurementTime).getTime() -
        new Date(b.measurementTime).getTime(),
    )
    .map((event) => ({
      latitude: event.lat,
      longitude: event.lng,
      horario: format(new Date(event.measurementTime), 'dd/MM/yyyy HH:mm:ss'),
      total_passageiros: event.delta,
    }));
